export default __webpack_public_path__ + "static/media/408.7fefdad2.gif";